import { REACT_APP_X_TOKEN, REACT_APP_ENV } from '~/utils';
import { Storage, Amplify } from '~/services';


type CustomRequest = {
  authorization?: string;
  };
  
export const interceptorsAuthHeaders = async (
  config: any,
): Promise<any & CustomRequest> => {
  const amplify = new Amplify();
  return {
    ...config,
    headers: {
      ...config.headers,
      'x-api-key': REACT_APP_X_TOKEN,
      'x-user-email': REACT_APP_ENV === 'LOCAL' ? 'local_developing@email.com.br' : null,
      'x-tenant-id': REACT_APP_ENV === 'LOCAL' ? 'e64d26d80b5b42cfb96142a84fbe2dae' : null,
      authorization: await amplify.getToken(),
    },
  };
};